import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Share, PlusSquare } from 'lucide-react';

const IOSInstallInstructions = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Install X7 Autoz</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-gray-600">
          <div className="flex items-start gap-3">
            <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
              <Share className="h-4 w-4 text-gray-700" />
            </div>
            <p>Tap the <strong>Share</strong> icon in Safari's toolbar.</p>
          </div>
          <div className="flex items-start gap-3">
            <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
              <PlusSquare className="h-4 w-4 text-gray-700" />
            </div>
            <p>Scroll down and tap <strong>Add to Home Screen</strong>.</p>
          </div>
          <div className="flex items-start gap-3">
            <div className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 text-sm font-semibold text-gray-700">
              3
            </div>
            <p>Tap <strong>Add</strong> — X7 Autoz will appear on your home screen like any other app.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default IOSInstallInstructions;
